import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

export function SentimentTooltip() {
  const { t } = useTranslation('solve-insights');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant='font14'>{t('common.sentimentTooltip')}</Typography>
    </Box>
  );
}
